<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="用户名" name="user_name"></c-form-item>
					<c-form-item type="input" label="姓名" name="user_realname"></c-form-item>
					<c-form-item type="input" label="部门" name="department"></c-form-item>
					<c-form-item type="input" label="手机号" name="phone"></c-form-item>
					<c-form-item type="select" label="用户类型" name="user_type" :options="userType"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="userState"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_sysmanage_user_add" color="sys" @click="createUser">新增用户</c-button>
			</m-operate>
			
			<c-table ref="table" code="sysmanage_user_list">
				<c-table-column
					label="用户名"
					name="user_name"
				>
				</c-table-column>
				
				<c-table-column
					label="用户姓名"
					name="user_realname"
				>
				</c-table-column>
				
				<c-table-column
					label="手机号码"
					name="phone"
				>
				</c-table-column>
				
				<c-table-column
					label="部门"
					name="department"
				>
				</c-table-column>
				
				<c-table-column
					label="用户类型"
					name="user_type"
				>
					<template v-slot="{data}">
						{{userTypeMap[data.user_type]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="角色权限"
					name="roles"
				>
				</c-table-column>
				
				<c-table-column
					label="是否启用"
					name="state"
				>
					<template v-slot="{data}">
						{{data.state == 2 ? '启用' : '禁用'}}
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button power="b_sysmanage_user_edit" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_sysmanage_user_role_edit" @click="roleConfig(data)">角色配置</c-table-button>
						<c-table-button power="b_sysmanage_user_update_state" v-if="data.state == 1" @click="updateState(2, data)">{{'启用'}}</c-table-button>
						<c-table-button power="b_sysmanage_user_update_state" v-if="data.state == 2" @click="updateState(1, data)">{{'禁用'}}</c-table-button>
						<c-table-button power="b_sysmanage_user_resetpwd" @click="resetPwd(data)" >重置密码</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="userEdit" :title="editState ? '编辑用户' : '新增用户'" width="600" @resolve="submitUser">
			<c-form ref="userForm">
				<c-form-item v-if="editState" type="input" label="用户名" name="user_name" readonly required></c-form-item>
				<c-form-item v-if="!editState" type="input" label="用户名" name="user_name"  required></c-form-item>
				<c-form-item v-if="!editState" type="password" label="登录密码" name="user_pwd" required></c-form-item>
				<c-form-item type="input" label="用户姓名" name="user_realname" required></c-form-item>
				<c-form-item type="select" label="用户类型" name="user_type" :options="userType" required></c-form-item>
				<c-form-item type="input" label="部门" name="department"></c-form-item>
				<c-form-item type="input" label="手机号码" name="phone" required></c-form-item>
				<c-form-item type="radio" label="用户状态" name="state" :options="userState" required></c-form-item>
				<c-form-item type="hidden" name="id"></c-form-item>
			</c-form>
		</c-dialog>
		
		<role-selector ref="roleSelector" multiple @resolve="submitRoleConfig"></role-selector>
	</page>
</template>

<script>
	import roleSelector from '@/components/service/role_selector.vue'
	import CryptoJs from '@/assets/script/lib/crypto-js'
	
	export default {
		name: 'm_sysmanage_user',
		
		components: {
			roleSelector
		},
		
		data() {
			return {
				userType: [{
					name: '系统用户',
					value: 2
				}],
				
				userState: [{
					name: '启用',
					value: 2
				}, {
					name: '禁用',
					value: 1
				}],
				userTypeMap:{2:'系统用户'},

				editState: false
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/sys_user/list',
					data
				});
			},
			
			createUser() {
				this.editState = false;
				this.$refs.userForm.clear();
				this.$refs.userEdit.open();
			},
			
			edit(val) {
				this.editState = true;
				this.$refs.userForm.set(val);
				this.$refs.userEdit.open();
			},

			resetPwd(val) {
				this.$confirm({
					text: '确定要重置【'+val.user_name+'】的密码吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/reset_pwd',
							data: {id:val.id},
							loading: true,
							success: data => {
								this.$message({
									text: data,
									icon: 'success'
								});
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},


			updateState(type,val) {
				this.$confirm({
					text: '确定要'+(type==2?'启用':'禁用')+'【'+val.user_name+'】吗？',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys_user/update_state',
							data: {id:val.id,state:type},
							loading: true,
							success: data => {
								this.$message({
									text: '操作成功',
									icon: 'success'
								});
								this.$refs.table.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			submitUser(stop) {
				stop();
				this.$refs.userForm.submit({
					url: this.editState ? '/sys_user/edit' : '/sys_user/add',
					rule: {
						user_name: [{
							type: 'empty',
							word: '请填写用户名',
							skip: () => {
								return this.editState;
							}
						}],
						user_pwd: [{
							type: 'empty',
							word: '请填写登录密码',
							skip: () => {
								return this.editState;
							}
						}],
						user_realname: '请填写用户姓名',
						user_type: '请选择用户类型',
						phone: '请填写手机号码',
						state: '请选择用户类型'
					},
					dataFormatter: data => {
						data.user_pwd = CryptoJs.MD5(data.user_pwd).toString();
						data.platform_type = 1;
						return data;
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.table.update();
						this.$refs.userEdit.close();
					}
				});
			},
		
			roleConfig(data) {
				this._roleConfig = data;
				this.$refs.roleSelector.open(data.id);
			},
			
			submitRoleConfig(data) {
				this.request({
					url: '/sys_user/user_role_edit',
					data: {
                        user_id: this._roleConfig.id,
						role_ids: Array.from(data, item => {
							return {
								role_id: item.id
							}
						})
					},
					loading: true,
					success: () => {
						this.$refs.table.update();
					}
				});
			}
		}
	}
</script>